// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DJSO","input":"styles_input__1Laoo"};